/**
 * Validates that given obj is an IImageSourceModel
 * @param obj
 */
export function isIImageSourceModel(obj) {
  return obj && obj.sourceType === 'image';
}